import React from 'react';

const HeroSection = ({ onStartDiagnosis }) => {
  return (
    <section className="relative px-5 pt-8 pb-10">
      {/* <div className="absolute top-0 right-[-10%] w-[300px] h-[300px] bg-blue-100/40 rounded-full blur-[80px] -z-10 opacity-60"></div> */}

      <div className="mb-4">
        <span className="inline-flex items-center px-2.5 py-1 rounded-md bg-blue-btn-primary/10 text-blue-btn-primary text-[10px] font-bold tracking-wider uppercase">
          Free Check
        </span>
      </div>

      <h1 className="text-text-main tracking-tight text-[28px] font-bold leading-[1.3] mb-5">
        あなたの頭皮、<br />
        今<span className="text-blue-btn-primary relative inline-block">
          どんな状態？
          <svg className="absolute w-full h-2 bottom-1 left-0 text-blue-btn-primary/20 z-10" preserveAspectRatio="none"
            viewBox="0 0 100 10">
            <path d="M0 5 Q 50 10 100 5" fill="none" stroke="currentColor" strokeWidth="8"></path>
          </svg>
        </span>
      </h1>

      <p className="text-slate-600 text-sm font-medium leading-relaxed mb-6">
        1分の簡易診断で"今のケアの方向性"がわかります。
      </p>

      <div className="space-y-2 mb-8">
        <div className="flex items-start gap-2 bg-slate-50 p-3 rounded-lg border border-slate-100/50">
          <span className="material-symbols-outlined text-blue-btn-primary !text-base shrink-0 mt-0.5">check_circle</span>
          <p className="text-xs text-slate-600 leading-relaxed">
            髪の悩みは、実は<span className="font-bold text-blue-btn-primary">"頭皮"</span>が関係していることもあります。
          </p>
        </div>
        <div className="flex items-start gap-2 bg-slate-50 p-3 rounded-lg border border-slate-100/50">
          <span className="material-symbols-outlined text-blue-btn-primary !text-base shrink-0 mt-0.5">check_circle</span>
          <p className="text-xs text-slate-600 leading-relaxed">
            頭皮を知ることは、<span className="font-bold text-blue-btn-primary">未来の髪づくり</span>の第一歩。
          </p>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 mb-8">
        <div className="flex flex-col items-center text-center gap-2 p-2">
          <div
            className="w-10 h-10 rounded-full bg-white border border-slate-100 flex items-center justify-center text-blue-btn-primary shadow-sm">
            <span className="material-symbols-outlined text-xl">visibility</span>
          </div>
          <span className="text-[10px] font-bold text-text-body leading-tight">状態を<br />見える化</span>
        </div>
        <div className="flex flex-col items-center text-center gap-2 p-2">
          <div
            className="w-10 h-10 rounded-full bg-white border border-slate-100 flex items-center justify-center text-blue-btn-primary shadow-sm">
            <span className="material-symbols-outlined text-xl">lightbulb</span>
          </div>
          <span className="text-[10px] font-bold text-text-body leading-tight">ケアの<br />ヒントが分かる</span>
        </div>
        <div className="flex flex-col items-center text-center gap-2 p-2">
          <div
            className="w-10 h-10 rounded-full bg-white border border-slate-100 flex items-center justify-center text-blue-btn-primary shadow-sm">
            <span className="material-symbols-outlined text-xl">spa</span>
          </div>
          <span className="text-[10px] font-bold text-text-body leading-tight">未来の髪の<br />土台づくり</span>
        </div>
      </div>

      <button
        onClick={onStartDiagnosis}
        className="w-full flex cursor-pointer items-center justify-center rounded-xl h-14 px-5 bg-blue-btn-primary hover:bg-blue-btn-primary/80 transition-all shadow-lg shadow-blue-btn-primary/20 text-white text-base font-bold tracking-wide group"
      >
        <span className="mr-2">1分で簡易診断をする</span>
        <span className="material-symbols-outlined group-hover:translate-y-1 transition-transform">arrow_downward</span>
      </button>
    </section>
  );
};

export default HeroSection;
